import React from "react";
import styled from "@emotion/styled";

const MainContentContainer = styled.div`
  display: grid;
  grid-template-columns: 494px 350px;
  grid-gap: 60px;

  @media (max-height: 700px), (max-width: 950px) {
    display: block;
    margin: 0 auto;
    max-width: 700px;
  }
  @media (max-width: 850px) {
    width: 85%;
  }
  @media (max-width: 728px) {
    width: 90%;
  }
`;

const MainContentSellContainer = ({ children }) => (
  <MainContentContainer>{children}</MainContentContainer>
);
export default MainContentSellContainer;
